// Вычисления по билету: ночной прилёт, сумма за пассажиров, время в пути, ночей в поездке
import type { Leg, Ticket } from '@sayohat/shared';
import { daysBetween } from '../../shared/lib/format';

const arrivalHour = (leg: Leg | null) => (leg && leg.arrivalAt ? Number(leg.arrivalAt.slice(11, 13)) : null);

/** Прилёт между 00:00 и 06:00 (туда или обратно) */
export const isNightArrival = (t: Ticket): boolean => [t.to, t.back].some((leg) => { const h = arrivalHour(leg); return h !== null && h < 6; });

export const totalDuration = (t: Ticket): number => (t.to.duration || 0) + (t.back ? t.back.duration || 0 : 0);

export const nightsOf = (t: Ticket): number | null => (t.back ? daysBetween(t.to.arrivalAt || t.to.departureAt, t.back.departureAt) : null);

export interface PaxCount {
  adults?: number | string | null;
  children?: number | string | null;
  infants?: number | string | null;
}

// Примерная сумма за всех: взрослые и дети по цене взрослого, младенец без места ~10%.
// Точную сумму считает продавец — детские тарифы у авиакомпаний разные.
export function paxTotal(price: number, q: PaxCount | null | undefined = {}): { count: number; total: number } | null {
  const adults = Number(q?.adults) || 1, children = Number(q?.children) || 0, infants = Number(q?.infants) || 0;
  const count = adults + children + infants;
  return count > 1 ? { count, total: Math.round(price * (adults + children) + price * 0.1 * infants) } : null;
}

/** Логотип авиакомпании (pics.avs.io), size — в CSS-пикселях */
export const logoUrl = (code: string, size = 32): string => `https://pics.avs.io/${size * 2}/${size * 2}/${encodeURIComponent(code)}.png`;

/** Необязательные поля билета: альянс, самолёты, живая цена (живой поиск по агентствам) */
export interface TicketExtras {
  alliance?: string | null;
  planes?: string[];
  live?: boolean;
}
export const extrasOf = (t: Ticket): TicketExtras => t as Ticket & TicketExtras;
